import { useEffect, useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Yeni sayfaya geçişte (link, footer, yönlendirme) sayfa en üstten açılır.
// Geri/ileri (POP) tarayıcının kaldığı yeri geri yüklemesine bırakılır;
// yalnızca ?sorgu değişimi (sekme, filtre, sayfalama) kaydırmaz; #bölüm bağlantısı o bölüme gider.
const useIsoLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useIsoLayoutEffect(() => {
    if (navigationType === 'POP') return undefined;
    window.scrollTo(0, 0);
    if (hash) {
      // Sayfa parçası (lazy) yüklenene kadar hedef bölümü kısa süre ara
      let tries = 0;
      const timer = window.setInterval(() => {
        tries += 1;
        let el = null;
        try {
          el = document.getElementById(decodeURIComponent(hash.slice(1)));
        } catch {
          el = null;
        }
        if (el) {
          el.scrollIntoView();
          window.clearInterval(timer);
        } else if (tries >= 20) {
          window.clearInterval(timer);
        }
      }, 50);
      return () => window.clearInterval(timer);
    }
    return undefined;
  }, [pathname, hash, navigationType]);

  return null;
};

export default ScrollToTop;
